module.exports = __webpack_public_path__ + "media/images/eu50-bd2bed50e06f36da57ec6fed3cc9c0ed.svg";